export const getSecondsFromDatesHoursAndMinutes = (date: Date): number =>
  date.getHours() * 60 * 60 + date.getMinutes() * 60 + date.getSeconds();
